import React from "react";
import Moment from "react-moment";
import "./style.css";
import Slider from "../Slider";
import { SwiperSlide } from "swiper/react";
import { getMediaType } from "../../helper";
import ReactPlayer from "react-player";
import Carousel from "../../Components/Carousel";

const ActivityCard = ({ data, id }) => {
  const options = {
    slidesPerView: 1,
    spaceBetween: 0,
    scrollbar: { hide: false },
    className: "mySwiper",
  };
  return (
    <div class="card border-0 pb-2">
      {data?.submissionUrl?.length > 1 ? <Carousel id={`gallery${id}`} newOptions={options}>
        {data?.submissionUrl?.map((item, key) => {
          const type = getMediaType(item);
          return (
            <SwiperSlide key={key}>
              {type === "image" && <div className="card-img"><img src={item} class="card-img-top" alt="dice" /></div>}
              {type === "video" && <div className="card-img"><ReactPlayer url={item} controls={true} width={"100%"} height={"100%"} /></div>}
            </SwiperSlide>
          )
        })}
      </Carousel> :
        <>
          {data?.submissionUrl?.map((item, key) => {
            const type = getMediaType(item);
            return (
              <>
                {type === "image" && <div className="card-img"><img src={item} class="card-img-top" alt="dice" /></div>}
                {type === "video" && <div className="card-img"><ReactPlayer url={item} controls={true} width={"100%"} height={"100%"} /></div>}
              </>
            )
          })}
        </>
      }

      <div class="card-body px-0">
        <p>{data?.activityName}</p>
        <p>{data?.kidName}, {data?.className}</p>
        <p><Moment format="DD-MM-YYYY">{new Date(data?.date)}</Moment></p>
      </div>
    </div>
  );
};

export default ActivityCard;
